<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'NLRP' },
                { text: 'Generate Activation' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Generate Activation Code</h3>

        <v-card>
            <v-card-title>
                Daftar Kode Aktivasi
                <v-spacer></v-spacer>
                <v-btn
                    id="tryout_tambah"
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createGenerateCode()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Kode Aktivasi
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="data"
                :headers="headers"
                :hasDownload="true"
                :has-custom-pagination="true"
                :has-custom-search="false"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="detailGenerateCode()"
                v-on:exportClicked="exportTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:downloadFile="downloadFile($event)"
                v-on:doSearch="
                    search = $event.value;
                    tableKey = $event.key.value;
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import { mapState } from "vuex";
import axios from "axios";
import Moment from "moment";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            selectedRow: null,
            total: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            data: [],
            problem: [],
            total_problem: 0,
            headers: [
                { text: "Tanggal", value: "generated_date", width: 200 },
                {
                    text: "Jumlah User",
                    value: "code_count",
                    align: "left",
                    width: 200,
                },
                { text: "Kelas", value: "grade", width: 200 },
                { text: "Paket", value: "package_name", width: 250 },
                { text: "Aksi", value: "actions", width: 200 },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
        };
    },

    watch: {
        pagination() {
            this.fetchData();
        },
        filter_type() {
            if (this.filter_type === "ALL") {
                this.date = "";
                this.date2 = "";
            } else {
                const date = new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000,
                )
                    .toISOString()
                    .substr(0, 10);

                const date2 = new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000,
                )
                    .toISOString()
                    .substr(0, 10);

                this.date = date;
                this.date2 = date2;
            }
        },
    },

    mounted: function () {
        this.fetchData();
    },

    computed: {
        ...mapState(["auth"]),
    },

    methods: {
        fetchData() {
            const context = this;
            const page =
                this.pagination.currentPage > 0
                    ? this.pagination.currentPage - 1
                    : 0;

            const param = `?page=${page}&size=${this.pagination.perPage}`;

            const url = `${process.env.API_BASE_URL}account/code/history/list${param}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.data = [];

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    response.data.list_history_codes.forEach(
                        function (content, index) {
                            var row = {
                                no: index,
                                id: content.id,
                                generated_date:
                                    Moment(content.generated_date).format(
                                        "DD/MM/YYYY",
                                    ) || "-",
                                code_count: content.code_count,
                                generator_name: content.generator_name,
                                package_name: content.package_name,
                                grade: content.grade,
                                file_url: content.file_url,
                            };

                            context.data.push(row);
                        },
                    );

                    context.total = Math.ceil(
                        response.data.total_codes / context.pagination.perPage,
                    );
                }
            });
        },
        doFilter() {
            this.menu = false;
            this.start_date = this.formatDate(this.date);
            this.end_date = this.formatDate(this.date2);

            this.fetchData();
            this.fetchListProblem();
        },
        doSearch() {
            if (this.tableKey === "class_date") {
                this.search = this.formatDate2(this.search);
            }
            this.fetchData();
        },
        formatDate(date) {
            if (!date) return "";

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        formatDate2(date) {
            if (!date) return "";

            return date.replaceAll("/", "-");
        },
        createGenerateCode() {
            if (this.auth.scopes.includes("admin_itembank")) {
                this.$router.push({ path: "/code-activation-form" });
            } else {
                this.$store.commit("showAlert", {
                    message: `Anda tidak memiliki akses untuk membuat Activation Code`,
                    type: "error",
                });
            }
        },
        detailGenerateCode() {
            this.$router.push({
                path: "/code-activation-detail",
                query: { id: this.selectedRow.id },
            });
        },
        downloadFile(item) {
            const context = this;
            const param = `document_url=${item.file_url}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/download/documentation?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    var url = response.data.download_url;
                    window.open(url, "_blank");
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// CodeActivation.vue?b1200262